export default __webpack_public_path__ + "static/P_SearchThumb_IN-4011_Downloads-9f5731cd73b1e6d13773d4e275cddbf1.webp";